import { Flex } from '@grupoboticario/flora-react';
import {
  CheckCircleFillIcon,
  ExclamationMarkHexagonFillIcon,
} from '@grupoboticario/flora-react-icons';

import { PrivacyPolicy } from 'components/Drawers/CadastralChange/AddressChange/components';
import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

export const AditionalMessage = ({
  message,
  isSuccess,
}: {
  message: string;
  isSuccess: boolean;
}) => {
  return (
    <Flex direction='column' gap='$4'>
      <Flex gap='$1' align='center'>
        {isSuccess ? (
          <CheckCircleFillIcon color='$success-standard' size={14} data-testid='success-icon' />
        ) : (
          <ExclamationMarkHexagonFillIcon
            color='$error-standard'
            size={14}
            data-testid='error-icon'
          />
        )}
        <ResponsiveFloraTypography fontSize='exceptionsAuxiliar' fontWeight='medium'>
          {message}
        </ResponsiveFloraTypography>
      </Flex>
      <PrivacyPolicy />
    </Flex>
  );
};
